<template>
  <div id="app" :class="appClass">
    <router-view :key="$route.path"></router-view>
    <claim-details v-if="claimModalShow"></claim-details>
    <leaderboard-modal v-if="leaderboardModalShow"></leaderboard-modal>
    <div v-if='impersonate === "true"' class="c-impersonate">
      <h2 class="c-impersonate__title">User session</h2>
      <p class="c-impersonate__username u-force-wrap">
        {{ participant.primary_email }}
        <span class="c-impersonate__username__name">
          ({{ participant.first_name }} {{ participant.last_name }})
        </span>
      </p>
    </div>

    <simplert ref="simplert"
      :useRadius="false"
      :useIcon="false">
    </simplert>

    <portal-target name="modal"></portal-target>
  </div>
</template>

<script>
import $ from 'jquery'
import Simplert from 'vue2-simplert'
import ClaimDetailsModal from '@/views/components/ClaimDetailsModal'
import LeaderboardModal from '@/views/components/LeaderboardModal'
import { mapGetters } from 'vuex'

export default {
  name: 'app',

  data () {
    return {
      impersonate: false
    }
  },

  components: {
    claimDetails: ClaimDetailsModal,
    leaderboardModal: LeaderboardModal,
    simplert: Simplert
  },

  mounted () {
    window.addEventListener('storage', (e) => {
      if (e.key === ('token_' + this.websiteConfig.id)) {
        let message = e.newValue !== null
          ? 'You have been logged in as another user in another tab.'
          : 'You have been logged out.'
        let obj = {
          message: message,
          type: 'info',
          customCloseBtnText: 'Ok',
          customCloseBtnClass: 'c-button t-button-primary',
          disableOverlayClick: true,
          onOpen: () => {
            $('body').addClass('has-modal')
          },
          onClose: () => {
            $('body').removeClass('has-modal')
            window.location.reload()
          }
        }
        this.$refs.simplert.openSimplert(obj)
      }
    })
  },

  // Changed computed impersonate because it was not updating the value correctly
  // after first load, updated event works fine for that purpose and keeps the impersonate
  // variable up to date with the correct value
  updated () {
    var impersonateName = 'impersonate_' + this.websiteConfig.id
    this.impersonate = localStorage[impersonateName] ? localStorage[impersonateName] : false
  },

  computed: {
    ...mapGetters({
      appName: 'appName',
      websiteConfig: 'websiteConfig',
      loggedIn: 'loggedIn',
      claimModalShow: 'claimModalShow',
      leaderboardModalShow: 'leaderboardModalShow',
      participant: 'participant'
    }),
    appClass () {
      return {
        'is-logged-in': this.loggedIn,
        'not-logged-in': !this.loggedIn
      }
    }
  }

}
</script>

<style lang="sass">
    @import 'resources/css/style'
</style>



// WEBPACK FOOTER //
// App.vue?87b19022